"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyEntitlementStatusToJSON = exports.LoyaltyEntitlementStatusFromJSONTyped = exports.LoyaltyEntitlementStatusFromJSON = exports.LoyaltyEntitlementStatus = void 0;
/**
 * entitlement status types
 * @export
 * @enum {string}
 */
var LoyaltyEntitlementStatus;
(function (LoyaltyEntitlementStatus) {
    LoyaltyEntitlementStatus["Accepted"] = "accepted";
    LoyaltyEntitlementStatus["Rejected"] = "rejected";
    LoyaltyEntitlementStatus["NewVersion"] = "newVersion";
})(LoyaltyEntitlementStatus = exports.LoyaltyEntitlementStatus || (exports.LoyaltyEntitlementStatus = {}));
function LoyaltyEntitlementStatusFromJSON(json) {
    return LoyaltyEntitlementStatusFromJSONTyped(json, false);
}
exports.LoyaltyEntitlementStatusFromJSON = LoyaltyEntitlementStatusFromJSON;
function LoyaltyEntitlementStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.LoyaltyEntitlementStatusFromJSONTyped = LoyaltyEntitlementStatusFromJSONTyped;
function LoyaltyEntitlementStatusToJSON(value) {
    return value;
}
exports.LoyaltyEntitlementStatusToJSON = LoyaltyEntitlementStatusToJSON;
//# sourceMappingURL=LoyaltyEntitlementStatus.js.map